/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import GUI                            from 'services/gui';
  import ApplicationState               from 'store/application'
  import {
    selectMixin,
    select2Mixin
  }                                     from 'mixins';
  import { getCatalogLayerById }        from 'utils/getCatalogLayerById';

  const PickLayerInputService           = require('gui/inputs/picklayer/service');
  const { Layer }                       = require('map/layers/layer');
  const InputMixin                      = require('gui/inputs/input');

  const G3W_SELECT2_NULL_VALUE = null; // need to set nul value instead of empty string

  function createSingleFieldParameter({ field, value, operator='eq', logicop='OR' }) {
    return [].concat(value).map(v => `${field}|${operator.toLowerCase()}|${encodeURIComponent(v)}`).join(`|${logicop},`);
  }

  const __vue_script__ = {

    /** @since 3.8.6 */
    name: 'input-select',

    mixins: [InputMixin, selectMixin, select2Mixin],
    data() {
      return {
        showPickLayer :       false,
        picked :              false,
        filterFields :        [], // each item is
        isFilterFieldsReady : false, /**{Boolean} @type it is used to show filter_fields select whe ready*/
      }
    },
    computed: {
      /**
       *
       * @returns {boolean}
       */
      showNullOption() {
        /**
         * In case of multiple select values, need to set doesn't show null value
         */
        return false === this.multiple && [undefined, true].includes(this.state.nullOption);
      },
      /**
       *
       * @returns {false|null}
       */
      select2NullValue() {
        return this.showNullOption && G3W_SELECT2_NULL_VALUE;
      },
    },
    methods: {
      /**
       *
       * @returns {Promise<void>}
       */
      async pickLayerValue() {
        try {
          if (this.picked) {
            this.pickLayerInputService.unpick();
            this.picked = false;
          } else {
            this.picked = true;
            const values = await this.pickLayerInputService.pick();

            let value = values[this.state.input.options.key];

            //check if is multiple and get value in not in current values
            if (this.multiple) {
              //set new value. If value is already selected, get current value of state.value
              value = undefined === this.getMultiValues().find(v => value == v) ? `{${[...this.getMultiValues(), value].join()}}` : this.state.value;
            }

            // Check if the value is change (Use comparison operator, NOT STRICT, because value and this.state.value can be different type Number, String)
            if (value != this.state.value) {
              if (this.autocomplete) {
                //in the case of no multipe values, need to reset values
                if (!this.multiple) { this.state.input.options.values.splice(0) }
                this.state.input.options.values.push({
                  key:    values[this.state.input.options.value]    ,
                  value:  values[this.state.input.options.key]
                });
              }
              //if autocpomplete is not set,just simple select check if value is not in current values
              //Case Bonifica Renana https://github.com/orgs/g3w-suite/projects/12/views/1?pane=issue&itemId=123189761&issue=g3w-suite%7Cg3w-admin%7C1180
              //use not strict equality to avoid issues with numbers and strings
              if (!this.autocomplete && !this.state.input.options.values.find(v => v.value == value)) {
                //set null value if no in values
                value = null;
              }
              //set new value to this.state.value
              await this.changeSelect(value);
              //trigger change value on select2
              this.select2.val(this.multiple ? this.getMultiValues() : value).trigger('change');
            }
            //show a success message
            if (value) {
              GUI.showUserMessage({ type: 'success', autoclose: true });
            }

            //In case of value is null, no value inside values, show warning message
            if (null === value) {
              GUI.showUserMessage({ type: 'warning', message: 'sdk.form.inputs.messages.warning.picklayer', autoclose: false });
            }

            this.picked = false;
          }
        } catch(e) {
          console.warn(e);
          GUI.showUserMessage({
            type:      "warning",
            message:   'sdk.form.inputs.messages.errors.picklayer',
            autoclose: true
          });
          this.picked = false;
        }
      },
      /**
       * @since 3.11.0
       * return <Array> values
       */
      getMultiValues() {
        return [undefined, null, ''].includes(this.state.value)
          ? [] //return empty array values
          : Array.from(
            new Set(
              `${this.state.value}`
                .replace(/^{|}$/g, '')  // Remove both open and close curly braces
                .replace(/"/g, "") //remove ""
                .split(','))
          ).filter(v => this.autocomplete || (this.state.input.options.values.map(({ value }) => `${value}`).includes(`${v}`)));
      },
      /**
       * Method to handle select2 event
       */
      setAndListenSelect2Change() {
        //Listen unselect/remove value
        this.select2.on('select2:unselect', (e) => {
          const value = e.params.data.$value
            ? e.params.data.$value
            : e.params.data.id;
          if (this.multiple) {
            //get array of values
            const values = this.getMultiValues().filter(v => v != value);
            //filter already added value, for example, by picked
            if (this.autocomplete) {
              this.state.input.options.values = this.state.input.options.values.filter(v => value != v.value);
            }
            this.changeSelect(0 === values.length ? null : `{${values.join()}}`);
          }

          if (this.showNullOption && !this.multiple) {
            this.changeSelect(null);
          }

        })

        this.select2.on('select2:select', e => {
          //get value from select2 option
          let value = e.params.data.$value
            ? e.params.data.$value
            : e.params.data.id;

          value = this.showNullOption
            ? value === G3W_SELECT2_NULL_VALUE

              ? null
              : value.toString()

            : value.toString();
          // in case of multiple select values, need to set value as {"value1", "value2",...}
          if (this.multiple) {
            value = (
              this.getMultiValues().length > 0
            ) ? `{${[...this.getMultiValues(), value].join()}}`
              : `{${value}}`
          }

          this.changeSelect(value);

        });
      }
    },

    watch: {
      /**
       *
       * @param {Array} values Array of key value objects
       * @return {Promise<void>}
       */
      async 'state.input.options.values'(values = []) {
        await this.$nextTick();
        if (this.autocomplete) {
          return;
        }
        let value;
        //check if is an empty array values
        const is_empty = 0 === values.length;
        //if values is empty array or current state.value {val1, val2} has not value of current values
        if (is_empty || (this.multiple && 0 === this.getMultiValues().length)) {
          //set null
          value = G3W_SELECT2_NULL_VALUE;
        }
        //in the case of multiple selection, need to set array values as select2
        if (!is_empty && this.multiple && this.getMultiValues().length > 0) {
          //get current value
          value = `{${this.getMultiValues().join()}}`;
        }
        //no empty values and not multiple select values
        if (!is_empty && !this.multiple) {
          value = (values.find(({ value }) => value == this.state.value) || { value:  G3W_SELECT2_NULL_VALUE }).value;
        }

        //check if changed value
        const changed    = value != this.state.value;

        //set value
        this.state.value = value;

        this.select2.val(this.multiple ? this.getMultiValues() : this.state.value).trigger('change');

        if (changed) {
          this.change();
        }
      }
    },

    async created() {

      //@since 4.0.1 Force to set usecompleter false if filter_expression is set
      //to avoid to handle filter_expression list results values with search text on autocomplete
      //this.state.input.options.usecompleter = this.state.input.options.usecompleter && !this.state.input.options.filter_expression;

      //unwatch attributes
      this.unwatch;
      this.filterFieldsUnwatches;

      const {
        relation_id,
        filter_fields =      [],
        relation_reference = false,
        chain_filters =      false, /** @type Boolean if true filter_fields select are related ech other*/
        allowmulti =         false, //@since v3.11.0 multi select value
      } = this.state.input.options;
      //set multiple values
      this.multiple = allowmulti;
        //In case of relation reference check if filter_fields is set
      if (relation_reference && Array.isArray(filter_fields) && filter_fields.length > 0) {
        //set loading true
        this.setLoading(true);
        /** {Boolean} @type it used to show component when all data are ready*/
        this.isFilterFieldsReady        = false;
        //data from relation
        const {
          referencedLayer,
          referencingLayer,
          fieldRef : { referencingField, referencedField }
        }                               = ApplicationState.project.getRelationById(relation_id);
        //current layer in editing
        const layer                     = getCatalogLayerById(referencingLayer)
        //relation layer
        const relationLayer             = getCatalogLayerById(referencedLayer);
        //fields of relation layer
        const relationLayerFields       = relationLayer.getFields();
        //check if it has a value
        if (null !== this.state.value) {
          try {
            //get a single feature used to set values of filter_fields
            const { data = [] } = await relationLayer.getFilterData({
              formatter : 0,
              field : createSingleFieldParameter({
                field : referencedField[0], // field related to relation (in case of relation_reference it is just one field)
                value : this.state.value // current input value. Is value related to field of relation layer
              })
            })
            //get all data referencing to al filter_fields values in fformatter
            // ad set values for input
            this.state.input.options.values = (
              (await layer.getFilterData({
                fformatter: referencingField[0],
                order:      referencingField[0],
                ffield:     filter_fields //create a filet with filter fields values (ex. field1|eq|1|AND,field2|eq|test)
                  .map((f, i) => {
                    const value = undefined === data[0].features[0].get(f) ? `${G3W_SELECT2_NULL_VALUE}` : data[0].features[0].get(f);
                    //get the value of filter_field from feature response
                    //and set as value. Used after to set initial value of filter field of select
                    this.filterFields.push({
                      id:     f, //field name
                      values: [
                        {
                          key: `[${relationLayerFields.find(_f => _f.name === f).label}]`,
                          value:`${G3W_SELECT2_NULL_VALUE}` //null
                        }
                      ], //values
                      value,
                      disabled: chain_filters
                        && i > 0
                        && `${G3W_SELECT2_NULL_VALUE}` === this.filterFields[filter_fields[i-1]],
                    })
                    return createSingleFieldParameter({
                      field: f,
                      value
                    })
                  }).join('|AND,')
                })).data || []).map(([value, key]) => ({key, value}));

            //in the case of chain_filters
            if (chain_filters) {
              //first filter field need to get all value avery time
              (await relationLayer.getFilterData({
                unique:    filter_fields[0],
                ordering:  filter_fields[0],
                formatter: 0,
              })).forEach(v => this.filterFields[0].values.push({ key: v, value: v }));

              (await Promise.allSettled(
                filter_fields
                  .slice(1)
                  .map((f,i) => {
                    return relationLayer.getFilterData({
                      unique:    filter_fields[i+1],
                      ordering:  filter_fields[i+1],
                      formatter: 0,
                      field: this.filterFields.slice(0, i+1)
                        .filter(f => 'null' !== f.value)
                        .map(f => createSingleFieldParameter({
                          field: f.id,
                          value: f.value
                        })).join('|AND,')
                    })
                  })
              ))
              .forEach(({ status, value: data }, i) => {
                if ('fulfilled' === status) {
                  data.forEach(v => this.filterFields[i+1].values.push({ key: v, value: v }));
                }
              })
            } else {
              //No chain filters
              (await Promise.allSettled(
                filter_fields.map(f => relationLayer.getFilterData({ unique: f, ordering: f, formatter: 0 }))
              ))
              .forEach(({ status, value: data }, index) => {
                if ('fulfilled' === status) {
                  //set values for all filer fields
                  data.forEach(v => this.filterFields[index].values.push({ key: v, value: v }));
                }
              });
            }
          } catch(e) {
            console.warn(e);
          }
        }
        else {
          //sett all values for all filter fields
          (await Promise.allSettled(
            filter_fields
              .map((f, i) => {
                this.filterFields.push({
                  id:     f, //field name
                  values: [
                    {
                      key: `[${relationLayerFields.find(_f => _f.name === f).label}]`,
                      value:`${G3W_SELECT2_NULL_VALUE}` //null
                    }
                  ], //values
                  value:    `${G3W_SELECT2_NULL_VALUE}`, //current value
                  disabled: chain_filters && i > 0,
                })
                return relationLayer.getFilterData({
                  unique :    f,
                  formatter : 0,
                  ordering :  f
                });
              })
          ))
          .forEach(({ status, value:data }, i) => {
            if ('fulfilled' === status) {
              data.forEach(v => this.filterFields[i].values.push({ key: v, value: v }))
            }
          });
        }

        //watch change of value
        this.filterFieldsUnwatches = this.filterFields.map((f, index) => {
          return this.$watch(
            () => f.value, // listen to change of value
            async (value) => {
              //set loading true
              this.setLoading(true);
              // in the case of chain_filters
              if (chain_filters) {
                //need to be disabled fields in a chain after current index
                for (let i = index + 1; i < this.filterFields.length; i++) {
                  this.filterFields[i].value    = `${G3W_SELECT2_NULL_VALUE}`;
                  this.filterFields[i].values   = [this.filterFields[i].values[0]];
                  this.filterFields[i].disabled = `${G3W_SELECT2_NULL_VALUE}` === value;
                }
                try {
                  const filter = this.filterFields
                    .slice(0, index + 1)
                    .filter((f) => `${G3W_SELECT2_NULL_VALUE}` !== f.value)
                    .map((f) => createSingleFieldParameter({
                      field: f.id,
                      value: f.value
                    })).join('|AND,');

                  const { data: rdata = [] } = await relationLayer.getFilterData({ field: filter });

                  if (rdata[0] && rdata[0].features) {
                    const filterReferencedFieldValues = [];
                    rdata[0].features.forEach((f => {
                      filterReferencedFieldValues.push(f.get(referencedField));
                      if (index < this.filterFields.length - 1) {
                        const value = f.get(this.filterFields[index + 1].id)
                        this.filterFields[index + 1].values.push({ key: value, value });
                      }
                    }))
                  }
                } catch(e) {
                  console.warn(e);
                }
              }
              //need to reset values of input select
              this.state.input.options.values.splice(0);
              await this.$nextTick();
              this.state.input.options.values = (
                (await layer.getFilterData({
                  fformatter : referencingField[0],
                  ordering :   referencingField[0],
                  ffield :     this.filterFields
                                 .filter((f) => `${G3W_SELECT2_NULL_VALUE}` !== f.value)
                                 .map((f) => createSingleFieldParameter({ field: f.id, value: f.value }))
                                 .join('|AND,')
                })).data || []).map(([value, key]) => ({ key, value }));
              //in the case of values length
              this.state.value = this.state.input.options.values?.[0]?.value ?? null;
              this.select2.val(this.state.value).trigger('change');
              await this.changeSelect(this.state.value);
              //stop loading
              this.setLoading(false);
            })
        })

        //stop loading
        this.setLoading(false);
        //filter fields are ready
        this.isFilterFieldsReady = true;
      }

      if ('select_autocomplete' === this.state.input.type) {
        //get dependency layer id if set
        const dependencyLayerId = this.state.input.options.layer_id;
        if (dependencyLayerId) {
          try {
            const dependencyLayer = GUI.getService('map')
              .getProjectLayer(dependencyLayerId)
              .getEditingLayer() || getCatalogLayerById(dependencyLayerId);
            // in case layer is on project, check if is non an alphanumeric layer
            //@since 4.0.1 if not autocompleter with filter_expression
            this.showPickLayer = dependencyLayer  && Layer.LayerTypes.TABLE !== dependencyLayer.getType() && !(this.autocomplete && this.state.input.options.filter_expression);
            if (this.showPickLayer) {
              const {
                key,
                value,
                layer_id
              } = this.state.input.options;

              //create pick layer service
              this.pickLayerInputService = new PickLayerInputService({
                layer_id,
                fields :    [value, key], //fields are key, and values
                //need to check if dependency layer is on editing,
                // so we can pick vector map layer, otherwise wms request is done
                pick_type : dependencyLayer.isStarted && dependencyLayer.isStarted() ? 'map' : null
              });
            }

          } catch(e) { console.warn(e); }
        }

      }
    },

    async mounted() {
      await this.$nextTick();

      const selectElement  = $(this.$refs.select);
      const language       =  this.getLanguage();
      const dropdownParent = undefined === this.state.dropdownParent && $('#g3w-view-content');
      if (this.autocomplete) {
        this.select2 = selectElement.select2({
          minimumInputLength: 1,
          dropdownParent,
          multiple:           this.multiple, //@since v3.11.0
          allowClear:         this.showNullOption,
          placeholder:        '', // need to set placeholder in case of allowClear, otherwise doesn't work
          language,
          // @since 4.0.1 In case of autocomplete with filter_expression, need to tranform data from feilter espression values
          data: this.state.input.options.filter_expression ? this.state.input.options.values.map(({key, value }) =>({
            text:   key,
            id:     value,
            $value: value, 
          })): null,
          // @since 4.0.1 In case of autocomplete with filter_expression, get dat from already loaded filter expression without ajax request (data attribute above)
          ajax: !this.state.input.options.filter_expression ? {
            delay: 250,
            transport: (params, success, failure) => {
              const search = params.data.term;
              // hide a previous result if present
              $('.select2-results__option.loading-results').siblings().hide();
              this.service.getData({
                key:   this.state.input.options.value,
                value: this.state.input.options.key,
                search
              })
                .then(values => success(values))
                .catch(e => { console.warn(e); failure(e); })
            },
            processResults: (data, params) => {
              params.page = params.page || 1;
              return {
                results: data,
                pagination: {
                  more: false
                }
              }
            }}: null,
        });
        //check if input has a value
        if (this.state.value) {
          //need to reset values otherwise can be repeated;
          this.state.input.options.values.splice(0);
          await this.service.getKeyByValue({
            search: this.multiple ? this.getMultiValues(): this.state.value
          });
        }
      } 
      
      //In case is not autocomplete (simple select)
      if (!this.autocomplete){
        this.select2 = selectElement.select2({
          language,
          dropdownParent,
          multiple:                this.multiple, //@since v3.11.0
          minimumResultsForSearch: this.isMobile() ? - 1 : null
        });
      }

      this.setAndListenSelect2Change();
      //in the case of multiple selection, need to set array values as select2
      if (this.multiple && this.getMultiValues().length > 0) {
        this.select2.val(this.getMultiValues()).trigger('change');
      } else {
        this.setValue();
      }

    },
    beforeDestroy() {
      if (this.pickLayerInputService) {
        this.pickLayerInputService.clear();
        this.pickLayerInputService = null;
      }
      if (this.unwatch) {
        this.unwatch();
        this.unwatch = null;
      }
      //in the case of filter fields need to remove all watch handlers
      if (this.filterFieldsUnwatches) {
        this.filterFieldsUnwatches.forEach(uw => uw());
        this.filterFieldsUnwatches = null;
      }
    }
  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baseinput',{attrs:{"state":_vm.state}},[(_vm.showPickLayer)?_c('span',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:top",value:('sdk.form.inputs.tooltips.picklayer'),expression:"'sdk.form.inputs.tooltips.picklayer'",arg:"top"},{name:"disabled",rawName:"v-disabled",value:(_vm.disabled),expression:"disabled"}],staticClass:"g3w-input-pick-layer skin-color",attrs:{"slot":"label-action"},on:{"click":function($event){$event.stopPropagation();return _vm.pickLayerValue.apply(null, arguments)}},slot:"label-action"},[_c('i',{class:_vm.g3wtemplate.font['crosshairs']})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.disabled),expression:"disabled"}],attrs:{"slot":"body","tabIndex":_vm.tabIndex},slot:"body"},[(_vm.filterFields.length > 0 && _vm.isFilterFieldsReady)?_c('div',{staticClass:"g3w-relation-reference-fields-content"},[_vm._l((_vm.filterFields),function(rf,index){return [_c('select',{directives:[{name:"select2",rawName:"v-select2",value:('filterFields'),expression:"'filterFields'"}],ref:("filterField_" + (rf.id)),refInFor:true,staticClass:"form-control",staticStyle:{"width":"100%"},attrs:{"select2_value":rf.value,"indexItem":index,"id":rf.id,"disabled":rf.disabled}},_vm._l((rf.values),function(ref){
var key = ref.key;
var value = ref.value;
return _c('option',{domProps:{"value":_vm.getValue(value)}},[_vm._v("\n            "+_vm._s(key)+"\n          ")])}),0)]}),_vm._v(" "),_c('divider')],2):_vm._e(),_vm._v(" "),_c('select',{ref:"select",staticClass:"form-control",staticStyle:{"width":"100%"}},[(_vm.showNullOption)?_c('option',{domProps:{"value":_vm.select2NullValue}}):_vm._e(),_vm._v(" "),_vm._l((_vm.state.input.options.values),function(ref){
var key = ref.key;
var value = ref.value;
return _c('option',{domProps:{"value":_vm.getValue(value)}},[_vm._v(_vm._s(key)+"\n      ")])})],2)]),_vm._v(" "),('error' === _vm.loadingState )?_c('p',{directives:[{name:"t",rawName:"v-t",value:('server_error'),expression:"'server_error'"}],staticClass:"error-input-message",attrs:{"slot":"message"},slot:"message"}):_vm._e()])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-6b0c866d_0", { source: ".g3w-input-pick-layer[data-v-6b0c866d]{cursor:pointer;position:relative;top:2px;font-size:1.2em}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-6b0c866d"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InputSelect.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__